import React from 'react';

import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type ControlledTextFieldProps = {
  id?: string;
  name: string;
  label?: string;
  required?: boolean;
  rules?: unknown;
  multiline?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  type?: string;
  adornment?: React.ReactNode;
  className?: string;
};

export const ControlledTextField = ({
  id,
  label,
  required = false,
  rules,
  name,
  multiline = false,
  variant,
  adornment,
  className,
}: ControlledTextFieldProps) => {
  const { t } = useTranslation();

  const defaultRules = required ? { required: t('form.required') } : {};
  return (
    <Controller
      name={name}
      rules={rules ? rules : defaultRules}
      render={({ field, fieldState }) => {
        const { value, ...rest } = field;

        const error = fieldState?.error;
        const errorMessage = error ? error?.message : null;
        const errorMessageToDisplay =
          errorMessage && typeof errorMessage === 'string'
            ? t(errorMessage)
            : ' ';
        return (
          <TextField
            id={id}
            error={!!error}
            value={value || ''}
            {...rest}
            variant={variant ? variant : 'outlined'}
            label={label}
            fullWidth
            multiline={multiline}
            rows={multiline ? 4 : 1}
            helperText={errorMessageToDisplay}
            className={className}
            slotProps={{
              input: {
                endAdornment: adornment,
              },
            }}
          />
        );
      }}
    />
  );
};
